/**
 * Готовая запись голоса: длина, форма волны, тексты ошибок (дословно как в ГиперЧАТе,
 * packages/chat-ui/src/hooks/useVoiceCapture.ts).
 */

/** Короче — случайное касание, а не голосовое. */
export const MIN_TAKE_MS = 700;
export const MAX_TAKE_MS = 15 * 60_000;
/** Столбиков живой волны во время записи — как у Ассистентуса. */
export const LIVE_BARS = 30;
const TAKE_BARS = 48;

export const TOO_SHORT_TEXT = 'Слишком коротко. Нажмите микрофон один раз — запись пойдёт, пока не остановите.';

export interface VoiceTake {
  blob: Blob;
  mime: string;
  durationMs: number;
  /** Форма записи — 48 столбиков от нуля до единицы. */
  peaks: number[];
}

/** Годится ли запись такой длины. */
export function checkTakeLength(durationMs: number): { ok: true } | { ok: false; error: string } {
  if (durationMs < MIN_TAKE_MS) return { ok: false, error: TOO_SHORT_TEXT };
  return { ok: true };
}

/** Сжать историю громкости до нужного числа столбиков и привести к 0..1. */
export function toPeaks(history: number[], bars = TAKE_BARS): number[] {
  if (history.length === 0) return Array.from({ length: bars }, () => 0.15);
  const out: number[] = [];
  for (let i = 0; i < bars; i += 1) {
    const from = Math.floor((i * history.length) / bars);
    const to = Math.max(from + 1, Math.floor(((i + 1) * history.length) / bars));
    let max = 0;
    for (let j = from; j < to && j < history.length; j += 1) max = Math.max(max, history[j] ?? 0);
    out.push(max);
  }
  const top = Math.max(...out, 0.01);
  return out.map((v) => Math.max(0.08, Math.min(1, v / top)));
}

export function describeMicError(e: unknown): string {
  const name = (e as Error)?.name;
  if (name === 'NotAllowedError') return 'Доступ к микрофону запрещён. Разрешите его в настройках телефона.';
  if (name === 'NotFoundError') return 'Микрофон не найден.';
  if (typeof navigator !== 'undefined' && !navigator.mediaDevices?.getUserMedia) {
    return 'Не удаётся записывать звук на этом устройстве.';
  }
  return `Не удалось начать запись: ${(e as Error)?.message ?? 'причина неизвестна'}`;
}

/** MM:SS для таймера записи. */
export function clock(totalSeconds: number): string {
  const s = Math.max(0, Math.floor(totalSeconds));
  return `${String(Math.floor(s / 60)).padStart(2, '0')}:${String(s % 60).padStart(2, '0')}`;
}
